// Cache ringan stale-while-revalidate: tampilkan data cache instan (<50ms),
// lalu refresh di background. Mencegah "lag lama" tiap navigasi.
const mem = new Map();

export function cacheGet(key) {
  if (mem.has(key)) {
    const e = mem.get(key);
    if (Date.now() < e.exp) return { data: e.data, stale: false };
    mem.delete(key);
  }
  try {
    const raw = localStorage.getItem(`swr:${key}`);
    if (raw) {
      const e = JSON.parse(raw);
      if (Date.now() < e.exp) {
        mem.set(key, e);
        return { data: e.data, stale: false };
      }
      localStorage.removeItem(`swr:${key}`);
    }
  } catch {}
  return { data: null, stale: true };
}

export function cacheSet(key, data, ttlMs = 60000) {
  const e = { data, exp: Date.now() + ttlMs };
  mem.set(key, e);
  try {
    localStorage.setItem(`swr:${key}`, JSON.stringify(e));
  } catch {}
}

export function cacheKey(userId, name) {
  return `${userId || "guest"}:${name}`;
}
